import React from "react"
import { Pickup } from "../../../../../../../../../../components/templates/chat/components/types/pickup"
import BaseDraftEditor from "../../abstract/base-draft-editor"
import { container } from "../container"

class Component extends BaseDraftEditor {
  public render() {
    return <Pickup content={this.props.content} />
  }
}

export const PickupEditor = container(Component)
